export default __webpack_public_path__ + "static/media/blog-ico.2e19fcdf.svg";